<template>
    <Form @submit="onSubmit">
        <div class="modal-header">
            <h4 class="modal-title">
                {{ $getLocaleMessage('buttons', 'updating') }} {{ selectedCompany.name }}
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="card-body">
                <div class="form-group">
                    <label for="name">Nombre de Empresa:</label>
                    <Field v-model="selectedCompany.name" type="text" class="form-control" name="name" placeholder="Nombre"
                    rules="required" />
                    <ErrorMessage name="name" class="input-error"></ErrorMessage>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label for="address">Ubicación:</label>
                        <Field v-model="selectedCompany.address" type="text" class="form-control" name="address"
                        placeholder="Ubicación" rules="required" />
                        <ErrorMessage name="address" class="input-error"></ErrorMessage>
                    </div>
                </div>
                <div class="form-group">
                    <label for="statusId">Estatus:</label>
                    <StatusSelect v-model="selectedCompany.statusId" :name="'statusId'" :options="statusOptions"></StatusSelect>                
                </div>
            </div>
        </div>
        <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $getLocaleMessage('buttons', 'cancel') }}</button>
            <PrimaryButton class="btn btn-primary" type="submit">
                {{ $getLocaleMessage('buttons', 'update') }}
            </PrimaryButton>
        </div>
    </Form>
</template>

<script>
import * as helper from '@/helpers';
import { mapState, mapActions } from 'pinia';
import { useCompaniesStore } from '@/pinia/companies.module';
import { useStatusStore } from '@/pinia/status.module';

import PrimaryButton from '@/Components/PrimaryButton.vue';
import StatusSelect from '@/Components/Selects/SelectField.vue';

export default {
    components: { PrimaryButton, StatusSelect },
    mixins: [],
    data() {
        return {
            selectedCompany: {},
        }
    },
    emits: ['new-changes'],
    props: {
        company: {
            type: Object,
            default: () => {}
        },
        editForm: false,
    },
    computed: {
        ...mapState(useStatusStore, ['getAllStatusByType']),
        statusOptions() {
            return helper.mapOptions(this.getAllStatusByType(1));
        },
    },
    methods: {
        ...mapActions(useCompaniesStore, ['updateCompany', 'updatePaginatedCompany']),
        onSubmit() {
            this.updateCompany(this.selectedCompany);
            this.updatePaginatedCompany(this.selectedCompany);
            this.emitUpdatedRecord();
            this.closeModal();
        },
        setNewStatus(newStatus) {
            // Setting up the new status into the selectedCompany property before sending it to the parent component
            this.selectedCompany.statusId = newStatus;
        },
        emitUpdatedRecord() {
            this.$emit('new-changes', this.selectedCompany)
        },
        closeModal() {
            this.$emit('closeModal', true);
        },
    },
    watch: {
        company: function() {
            this.selectedCompany = this.company;
        }
    },
    created() {
        this.selectedCompany = this.company;
    },
    mounted() {}
};
</script>